import { http, HttpResponse, PathParams } from 'msw';
import { apiUrl } from '../apiUrl';
import { AccountApiPaths } from '../../../slices/account-api.slice';
import { availableLocales } from '../../data/userInfo';
import { AuthApiPaths } from '../../../slices/auth-api.slice';
import { db } from '../../db/db';

export const mockGetAvailableLocalesQuery = http.get(apiUrl(AccountApiPaths.getAvailableLocales), () =>
    HttpResponse.json(availableLocales)
);
export const mockUpdateUserLocaleMutation = http.put<PathParams, { locale: string }>(
    apiUrl(AccountApiPaths.updateUserLocale),
    async ({ request }) => {
        const { locale } = await request.json();

        db.userInfo.update({
            where: {
                email: {
                    equals: db.userInfo.getAll()[0].email
                }
            },
            data: {
                locale: locale
            }
        });

        return new HttpResponse();
    }
);

export const mockUpdateEnrollingLocaleMutation = http.put<PathParams, { locale: string }>(
    apiUrl(AuthApiPaths.enrollmentLocaleSubmit),
    async ({ request }) => {
        const { locale } = await request.json();
        return HttpResponse.json({ locale });
    }
);

export const locale = [mockGetAvailableLocalesQuery, mockUpdateUserLocaleMutation, mockUpdateEnrollingLocaleMutation];
